import {addDocByName} from "@/shared/firebase_utils";

class EventTrigger {
  constructor({ hasRun = false, message = "", multiconnectId = "", timeToRun = null, type = "", fieldType = "", businessProfileId = "", userName = "", email = "", timeSlotInMinutes = 0, businessCardId = "", notificationType = "", templateId = "", initiatorsFirstName = "", initiatorsLastName = "", initiatorsDynamicLink = "", firstName = "", lastName = "" }) {
    (this.hasRun = hasRun || false),
      (this.message = message || ""),
      (this.multiconnectId = multiconnectId || ""),
      (this.timeToRun = timeToRun || null),
      (this.type = type || ""),
      (this.fieldType = fieldType || ""),
      (this.businessProfileId = businessProfileId || ""),
      (this.userName = userName || ""),
      (this.email = email || ""),
      (this.timeSlotInMinutes = timeSlotInMinutes || 0),
      (this.businessCardId = businessCardId || ""),
      (this.notificationType = notificationType || ""),
      (this.templateId = templateId || ""),
      (this.initiatorsFirstName = initiatorsFirstName || ""),
      (this.initiatorsLastName = initiatorsLastName || ""),
      (this.initiatorsDynamicLink = initiatorsDynamicLink || ""),
      (this.firstName = firstName || ""),
      (this.lastName = lastName || "");

  }

  toFireStore() {
    return {
      hasRun: this.hasRun || false,
      message: this.message || "",
      multiconnectId: this.multiconnectId || "",
      timeToRun: this.timeToRun || null,
      type: this.type || "",
      fieldType: this.fieldType || "",
      businessProfileId: this.businessProfileId || "",
      userName: this.userName || "",
      email: this.email || "",
      timeSlotInMinutes: this.timeSlotInMinutes || 0,
      businessCardId: this.businessCardId || "",
      notificationType: this.notificationType || "",
      templateId: this.templateId || "",
      initiatorsFirstName: this.initiatorsFirstName || "",
      initiatorsLastName: this.initiatorsLastName || "",
      initiatorsDynamicLink: this.initiatorsDynamicLink || "",
      firstName: this.firstName || "",
      lastName: this.lastName || ""
    };
  }

  async save(){
    //Save to firestore
    try {
      await addDocByName("triggers", this.toFireStore());
    } catch (error) {
      console.log("Error occurred while adding event to triggers collection in firestore - ", error.message);
    }
  }
}

export default EventTrigger;
